import type { ActionContext } from 'vuex'
import type { ActionClass, ToolingPagination, ToolingState } from '../../../models'
import type { StorageService } from '../../../services/interfaces'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { TOOLING_CONSTS } from '../tooling.consts'

export class SetPaginationAction implements ActionClass {
  static execute(
    this: void,
    { commit }: ActionContext<ToolingState, unknown>,
    pagination: ToolingPagination,
  ): void {
    commit(TOOLING_CONSTS.mutations.setPagination, pagination)

    const storageService = CONTAINER.get<StorageService>(TYPES.StorageService)
    storageService.setItem(TOOLING_CONSTS.storage.itemsPerPage, `${pagination.itemsPerPage}`)
  }
}
